import { render, staticRenderFns } from "./JourneyKanbanActionPill.vue?vue&type=template&id=f32ad66a"
import script from "./JourneyKanbanActionPill.vue?vue&type=script&lang=js"
export * from "./JourneyKanbanActionPill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports